import type { CollectedValues } from "./types";

/** Merge server-side auto-advance patches into client/Slack collected state. */
export function applyCollectedPatch(
  collected: CollectedValues,
  patch?: Partial<CollectedValues>,
): CollectedValues {
  if (!patch) return collected;
  return {
    ...collected,
    ...patch,
    picks: patch.picks ? { ...collected.picks, ...patch.picks } : collected.picks,
    fields: patch.fields ? { ...collected.fields, ...patch.fields } : collected.fields,
    extras: patch.extras ? { ...collected.extras, ...patch.extras } : collected.extras,
  };
}

export function hasCollectedPatch(patch?: Partial<CollectedValues>): boolean {
  if (!patch) return false;
  if (patch.bulkPick?.ids?.length) return true;
  if (patch.picks && Object.keys(patch.picks).length > 0) return true;
  if (patch.confirmed === true) return true;
  return false;
}
